import Project from "../components/Project.jsx";
import { Typography } from "@mui/material";

import ReactPlayer from "react-player";

export default function Main() {
  return (
    <Project
      title="Clinical Trial Data Automation"
      picture={
        <ReactPlayer controls muted url="https://youtu.be/vLXmLOkM1Js" />
      }
      text={
        <Typography align="justify" sx={styles.text}>
          Architected a full-stack Chrome browser extension to automate clinical
          trial data entry end-to-end. Leveraged LLMs to dynamically analyze the
          DOM structure of any website, extracting and semantically interpreting
          form inputs and questions with no hardcoded logic. Benchmarked
          different models across accuracy, reliability, and speed metrics to
          optimize model choice. Built a Node.js caching backend that stored
          previously parsed website form structures, eliminating redundant LLM
          calls. Developed an intelligent answer-matching system that queried a
          structured response database, contextually assigned answers to form
          fields, and automatically modified responses to fit specific question
          requirements. Built the extension frontend in React, delivering a
          seamless UI with a one-click trigger that instantly automated the
          entire data entry process. Eliminated hours of manual data entry per
          trial submission, replacing a complex multi-step process with a single
          click.
        </Typography>
      }
    />
  );
}

const styles = {
  text: {
    width: 0.9,
    fontSize: 20,
  },
};
